import axios from "axios";
import { Message } from "element-ui";
import router from "../router";

const isDev = process.env.NODE_ENV === "development";

export const $yunqueAxios = axios.create({
  baseURL: "/douyin-api",
});

export const $jdAxios = axios.create({
  baseURL: "/jd-yusms-api",
});

// 添加响应拦截器函数
const addInterceptors = (instance) => {
  instance.interceptors.response.use(
    (res) => {
      if (res.status === 200) {
        // 响应拦截器
        if (!res.data.hasOwnProperty("code")) {
          return Promise.resolve(res.data);
        }
        if (res.data.message == "请登录" || res.data.message == "未登录") {
          sessionStorage.removeItem("activeSideMenuId");
          sessionStorage.removeItem("BiTopMenuId");
          if (isDev) {
            router.replace("/login");
          } else {
            window.open("https://yz.yqcrm.cn/login", "_self");
          }
          return Promise.reject(res.data.message);
        }
        if (
          res.data.code == "200" ||
          res.data.code == "501" ||
          res.data.code == "1"
        ) {
          return Promise.resolve(res.data);
        } else if (
          res.data.code === "0" &&
          res.data.message == "正在处理请求中,请不要重复请求"
        ) {
          return Promise.resolve(res.data);
        } else if (res.data.code === -1) {
          window.open("https://yz.yqcrm.cn/login", "_self");
        } else if (res.data.code == 10001) {
          window.open("https://yz.yqcrm.cn/login", "_self");
        } else if (res.data.code == 0) {
          Message.error(res.data.message);
          return Promise.reject(res.data);
        } else if (res.data.code == -500) {
          Message.error(res.data.message || "服务器开小差啦");
          return Promise.reject(res);
        } else {
          if (res.data.message) {
            Message.error(res.data.message);
          } else {
            Message.error(res.message);
          }
          return Promise.resolve(res.data);
        }
      } else {
        Message.error(res.statusText);
        return Promise.reject(res.statusText);
      }
    },
    (error) => {
      errorState(error);
      return Promise.reject(error);
    }
  );
};

// 为两个实例添加拦截器
addInterceptors($yunqueAxios);
addInterceptors($jdAxios);
